import loadable from '@loadable/component';
import purchaseReviewPageStoreQuery from './query.graphql';
import editVerifiedShopReviewQuery from './edit-verified-shop-review-query.graphql';

export const CreateVerifiedShopReviewPage = loadable(() =>
  import(
    /* webpackChunkName: "verified-reviews" */ './create-verified-shop-review-page'
  )
);

CreateVerifiedShopReviewPage.variables = props => {
  return { id: props.shop_id, code: props.code };
};

CreateVerifiedShopReviewPage.graphQL = purchaseReviewPageStoreQuery;

export const EditVerifiedShopReviewPage = loadable(() =>
  import(
    /* webpackChunkName: "verified-reviews" */ './edit-verified-shop-review-page'
  )
);

EditVerifiedShopReviewPage.variables = props => {
  const reviewId = `i${props.review_id.replace('i', '')}`;
  return { shopId: props.shop_id, reviewId };
};

EditVerifiedShopReviewPage.graphQL = editVerifiedShopReviewQuery;
